<template>
  <div class="col-md-4 article-snippet">
    <a :href="guid" target="_blank">
			<img class="img-fluid" :src="featuredImageUrl" />
		</a>
    <h3 style="margin-top: 1em">{{ title }}</h3>
    <p class="snippet">{{ formattedDescription }}</p>
    <p><a class="readmore" :href="guid">Read More</a></p>
  </div>
</template>
<script>
export default {
  props: [
    "featuredImageUrl",
    "title",
    "formattedDate",
    "formattedDescription",
    "guid",
  ],
};
</script>